import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ParcelProperty } from '@core/api/angular';
import { FormatAddressPipe } from '@lassi/webapp-shared-pipes';

@Component({
  selector: 'lib-parcel-property-table',
  imports: [CommonModule, FormatAddressPipe],
  template: `
    <div class="property-section-table">
      <h4 class="mat-title-medium">Properties</h4>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>LGA</th>
            <th>PropNum</th>
            <th>Address</th>
            <th>PropPFI</th>
            <th>Area</th>
          </tr>
        </thead>
        <tbody>
          @for (property of parcelProperties(); let i = $index; track i) {
            <tr>
              <td>Property {{ i + 1 }}</td>
              <td>{{ property.property_lga_code }}</td>
              <td>{{ property.property_propnum }}</td>
              <td>{{ property.ezi_address | formatAddress }}</td>
              <td>{{ property.property_pfi }} {{ parcelStatus() }}</td>
              <td>
                {{ property.property_area | number }}
                @if (property.property_area) {
                  m<sup>2</sup>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  `,
  styles: `
    .property-section-table {
      margin-top: 16px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      background-color: var(--property-bg-color);
    }

    th,
    td {
      padding: 8px;
      text-align: left;
      border-bottom: 1px solid #ddd;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParcelPropertyTableComponent {
  parcelProperties = input.required<ParcelProperty[]>();
  parcelStatus = input<string>('');
}
